import React, { useEffect, useState } from 'react';
import { getImage } from '../../../utils/CFuncs';
import { useSelector } from 'react-redux';
import moment from 'moment';

export default function ImgCarousel({ diagnosisInd }) {
  const [index, setIndex] = useState(0);
  const [images, setImages] = useState([]);
  const { patient } = useSelector((state) => state.user);

  useEffect(() => {
    console.log('patient?.diagnosis');
    console.log(patient?.diagnosis);

    if (patient?.diagnosis && patient?.diagnosis.length > 0) {
      const imageId = patient.diagnosis[diagnosisInd].imageId;
      if(!imageId ){
        setImages([]);
      }else{
        getImage(imageId).then((res) => {
          setImages(res);
        });
      }
    }
  }, [patient.diagnosis, diagnosisInd]);

  const getUrl = (base64String) => {
    if (images.length == 0) {
      return `data:image/jpeg;base64,`;
    }
    return `data:image/jpeg;base64,${base64String}`;
  };
  const getDate = () => {
    if (patient?.diagnosis && patient?.diagnosis[diagnosisInd]) {
      return new Date(patient.diagnosis[index].timestamp).toLocaleString();
    }
    return null;
  };
  const decrease = () => {
    if (index > 0) {
      setIndex((prev) => prev - 1);
    }
  };
  const increase = () => {
    if (index < images?.length - 1) {
      setIndex((prev) => prev + 1);
    }
  };

  return (
    <div className="row" style={{ alignItems: 'center' }}>
      <div style={{ ...style.buttonScroll, fontSize: 36 }} onClick={decrease}>
        {'<'}
      </div>

      <div style={{ margin: 5 }}>
        <img src={getUrl(images[index])} alt={!images[index] ? 'Image not availible ' : undefined} width={250} height={400} />
        <div>Radiograph date: {getDate()}</div>
      </div>

      <div style={{ ...style.buttonScroll, fontSize: 36 }} onClick={increase}>
        {'>'}
      </div>
    </div>
  );
}

const style = {
  buttonScroll: {
    cursor: 'pointer',
    border: 'none',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
};
